import React from 'react';
import RoleUtility from '../utilities/roleUtility';
import _ from 'lodash';
import { USER_ROLES as Roles } from '../utilities/constants';

const Auth = ({ approvedRoles, children }) => {
  const targetRole = parseInt(localStorage.getItem('role_id'), 10);
  const approvedRolesWithSystemUser = _.concat(approvedRoles, Roles.system);
  if (RoleUtility.hasRole(targetRole, approvedRolesWithSystemUser)) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  return null;
};

export default Auth;



// WEBPACK FOOTER //
// ./src/components/Auth.jsx